import { AxiosError } from 'axios';
import { REPORT_ERROR } from 'b2b-apps/shop/common/redux/errors/actionTypes';
import { ReportErrorAction } from 'b2b-apps/shop/common/redux/errors/types';

const reportError = (
  message: string,
  error: AxiosError | Record<string, any> | unknown,
  additionalData: Record<string, any> = {},
  ignoreNetwork = true,
): ReportErrorAction => ({
  type: REPORT_ERROR,
  payload: {
    additionalData,
    error,
    ignoreNetwork,
    message,
  },
});

export { reportError };
